import { render, staticRenderFns } from "./IndicatorMetaDataModal.vue?vue&type=template&id=1f50fc7c&scoped=true&"
import script from "./IndicatorMetaDataModal.vue?vue&type=script&lang=js&"
export * from "./IndicatorMetaDataModal.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorMetaDataModal.vue?vue&type=style&index=0&id=1f50fc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50fc7c",
  null
  
)

export default component.exports